(() => {
  'use strict';
  const init = () => {
    const root = document.body;
    if (!root.classList.contains('wellumi-store') || root.dataset.wellumiReady) return;
    root.dataset.wellumiReady = 'true';
    const strings = JSON.parse(document.getElementById('wellumi-strings').textContent);
    const route = window.Shopify?.routes?.root || '/';
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const all = selector => [...document.querySelectorAll(selector)];
    const setText = (selector, value) => all(selector).forEach(node => { node.textContent = value; });
    const announce = value => setText('[data-announcement]', value);
    const offer = { packs: 3, price: 65 };
    let cart = null;
    let lastTrigger = null;

    const saleTimer = document.querySelector('[data-fall-sale-timer]');
    if (saleTimer) {
      const duration = (8 * 60 + 22) * 1000;
      const storageKey = 'wellumi-fall-sale-deadline-v1';
      let deadline = Date.now() + duration;
      try {
        const saved = Number(sessionStorage.getItem(storageKey));
        if (saved > Date.now()) deadline = saved;
        else sessionStorage.setItem(storageKey, String(deadline));
      } catch (_) { /* Timer still works if storage is unavailable. */ }
      let interval;
      const tick = () => {
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        saleTimer.querySelector('[data-fall-sale-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        saleTimer.querySelector('[data-fall-sale-minutes]').textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
        saleTimer.querySelector('[data-fall-sale-seconds]').textContent = String(remaining % 60).padStart(2, '0');
        if (remaining === 0 && interval) clearInterval(interval);
      };
      tick();
      if (deadline > Date.now()) interval = setInterval(tick, 1000);
    }

    const open = (id, trigger) => {
      document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      lastTrigger = trigger || document.activeElement;
      document.getElementById(id).showModal();
      root.classList.add('dialog-open');
    };
    const close = dialog => {
      dialog.close();
      if (!document.querySelector('dialog[open]')) root.classList.remove('dialog-open');
      lastTrigger?.focus();
    };
    const selectedInput = () => document.querySelector('input[name="wellumi-bundle"]:checked');
    const updateOffer = () => {
      const selected = selectedInput();
      if (!selected) return;
      offer.packs = Number(selected.value);
      offer.price = Number(selected.dataset.price);
      const variant = document.querySelector('[data-selected-variant]');
      if (variant) variant.value = selected.dataset.variantId || '';
      const addButton = document.querySelector('[data-add-cart]');
      if (addButton) {
        addButton.disabled = selected.dataset.available !== 'true';
        addButton.querySelector('.ab-albl').textContent = addButton.disabled ? 'SOLD OUT' : strings.addBag;
      }
      setText('[data-selected-price]', money.format(offer.price));
      setText('[data-selected-packs]', `${offer.packs} ${offer.packs === 1 ? strings.pack : strings.packs}`);
      const savings = offer.packs * 30 - offer.price;
      all('[data-selected-compare]').forEach(node => {
        node.textContent = money.format(offer.packs * 30);
        node.hidden = !savings;
      });
      all('.bundle').forEach(label => {
        const checked = label.querySelector('input').checked;
        label.classList.toggle('selected', checked);
        label.classList.toggle('ab-active', checked);
      });
    };
    const requestCart = async () => {
      const response = await fetch(`${route}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Could not load your cart. Please try again.');
      return response.json();
    };
    const updateCart = async () => {
      cart = await requestCart();
      setText('[data-cart-count]', cart.item_count);
      const filled = cart.item_count > 0;
      all('[data-cart-filled]').forEach(node => { node.hidden = !filled; });
      all('[data-cart-empty]').forEach(node => { node.hidden = filled; });
      if (!filled) return;
      const line = cart.items.find(item => item.product_id === 11371883102550) || cart.items[0];
      const packs = Number((line.variant_title || '1').match(/^\d+/)?.[0] || 1);
      setText('[data-cart-packs]', packs);
      setText('[data-cart-pack-label]', packs === 1 ? strings.packLabel : strings.packsLabel);
      setText('[data-cart-item-price]', money.format(line.final_line_price / 100));
      setText('[data-cart-subtotal]', money.format(cart.total_price / 100));
      setText('[data-cart-shipping]', cart.total_price >= 6500 ? strings.freeShipping : strings.shippingBelowThreshold);
      const image = document.querySelector('[data-cart-image]');
      if (image && line.image) image.src = line.image;
    };
    const postCart = async (path, body) => {
      const response = await fetch(`${route}${path}`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not update your cart.');
      return data;
    };
    const showError = message => {
      const error = document.querySelector('[data-cart-error]');
      if (error) { error.textContent = message; error.hidden = false; }
      announce(message);
    };

    document.addEventListener('change', event => {
      if (event.target.matches('input[name="wellumi-bundle"]')) updateOffer();
    });
    const form = document.getElementById('wellumi-product-form');
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('[data-add-cart]');
      const error = form.querySelector('[data-cart-error]');
      if (error) error.hidden = true;
      const variantId = Number(form.querySelector('[data-selected-variant]')?.value);
      if (!variantId) { showError('This pack is unavailable right now.'); return; }
      const item = { id: variantId, quantity: 1 };
      button.disabled = true;
      try {
        await postCart('cart/add.js', { items: [item] });
        await updateCart();
        open('wellumi-cart', button);
        announce(strings.added);
      } catch (error) { showError(error.message); }
      finally { button.disabled = false; }
    });
    document.addEventListener('click', async event => {
      const trigger = event.target.closest('button');
      if (!trigger) return;
      if (trigger.matches('[data-menu]')) {
        const nav = document.querySelector('.mobile-nav');
        nav.hidden = !nav.hidden;
        trigger.setAttribute('aria-expanded', String(!nav.hidden));
      }
      if (trigger.matches('[data-open-cart]')) {
        try { await updateCart(); open('wellumi-cart', trigger); }
        catch (error) { showError(error.message); }
      }
      if (trigger.matches('[data-close-dialog]')) close(trigger.closest('dialog'));
      if (trigger.matches('[data-gallery-src]')) {
        const main = document.querySelector('.main-gallery-image');
        main.src = trigger.dataset.gallerySrc;
        main.alt = trigger.querySelector('img').alt;
        all('[data-gallery-src]').forEach(button => {
          button.classList.toggle('active', button === trigger);
          button.setAttribute('aria-pressed', String(button === trigger));
        });
      }
      if (trigger.matches('[data-remove-cart]') && cart?.items?.length) {
        const line = cart.items.find(item => item.product_id === 11371883102550) || cart.items[0];
        trigger.disabled = true;
        try { await postCart('cart/change.js', { id: line.key, quantity: 0 }); await updateCart(); announce(strings.removed); }
        catch (error) { showError(error.message); }
        finally { trigger.disabled = false; }
      }
      if (trigger.matches('[data-sticky-buy]')) {
        const options = document.querySelector('.bundle-options');
        if (options) {
          options.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
          options.querySelector('input:checked').focus({ preventScroll: true });
        } else window.location.href = `${route}products/wellumi-saffron-gummies-for-kids`;
      }
    });
    all('dialog').forEach(dialog => {
      dialog.addEventListener('cancel', () => root.classList.remove('dialog-open'));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(dialog);
      });
    });
    all('.mobile-nav a').forEach(link => link.addEventListener('click', () => {
      document.querySelector('.mobile-nav').hidden = true;
      document.querySelector('[data-menu]').setAttribute('aria-expanded', 'false');
    }));
    const purchaseButton = document.querySelector('[data-add-cart]');
    const sticky = document.querySelector('.sticky-buy');
    if (purchaseButton && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0.2 }).observe(purchaseButton);
    }
    updateOffer();
    updateCart().catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
